<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useVigiaSummary } from 'dashboard/composables/useVigiaSummary';

const POLL_MS = 60000;

const { t } = useI18n();
const { currentAccount } = useAccount();
const { enabled, mine, refresh } = useVigiaSummary();
const countLabel = computed(() => (mine.value > 99 ? '99+' : mine.value));
let timer = null;

onMounted(async () => {
  // A conta já diz se tem o módulo; sem ele o resumo responde 402 e o
  // navegador mostra o erro no console. Sem a informação, pergunta.
  if (currentAccount.value?.vigia_enabled === false) {
    enabled.value = false;
    return;
  }
  const keepPolling = await refresh();
  if (keepPolling) timer = setInterval(refresh, POLL_MS);
});

onBeforeUnmount(() => {
  if (timer) clearInterval(timer);
});
</script>

<template>
  <RouterLink
    v-if="enabled"
    :to="{ name: 'vigia_index' }"
    :title="t('VIGIA.BUTTON_TITLE')"
    class="relative flex items-center justify-center rounded-lg size-9 shrink-0 hover:bg-n-alpha-2 transition-colors text-n-slate-11"
  >
    <span class="flex-shrink-0 i-lucide-siren size-4" />
    <span
      v-if="mine > 0"
      data-test="vigia-count"
      class="absolute -top-0.5 -right-0.5 min-w-4 h-4 px-1 rounded-full bg-n-ruby-9 text-white text-[10px] leading-4 text-center tabular-nums"
    >
      {{ countLabel }}
    </span>
  </RouterLink>
</template>
